import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import './DataGrid.css';
import { DataGridProps, DataGridState } from './Interface';
import DownloadCsv from './Plugins/DownloadCsv';
import Search from './Plugins/Search/Search';
import Filter from '../Filter/Filter';


interface IDataRow {
    [column: string]: string | number | Date | any;
}

class DataGrid<D extends IDataRow, C> extends React.Component<DataGridProps<D>, DataGridState> {

    constructor(props_: DataGridProps<D>) {
        super(props_);

        this.state = {
            isRowExpanded: false
        }
    }

    componentDidMount(): void {
        console.log(this.props.defaultSearch + "DataTools");
    }

    public render() {
        return (
            <>
                <div className='dt-table-header-container'>
                    {
                        this.props.title && <h1>{this.props.title}</h1>
                    }
                    <div className='dt-table-header'>
                        {
                            this.props.search && <Search
                                onSearch={(searchData: string) => {
                                    if (this.props.onSearch) {
                                        this.props.onSearch(searchData);
                                    }
                                }}
                                searchPlaceholder={this.props.search}
                                defaultValue={this.props.defaultSearch}
                            />
                        }
                        {
                            this.props.filter && (
                                <Filter
                                    onFilter={(filters: any) => {
                                        if (this.props.onFilter) {
                                            this.props.onFilter(filters);
                                        }
                                    }}
                                    accountType={this.props.accountType}
                                />)
                        }
                        {
                            this.props.exportCsv && <DownloadCsv data={this.props.data} columns={this.props.columns} />
                        }
                    </div>
                </div>

                <DataTable
                    dense={this.props.dense}
                    className='passport-datagrid'
                    fixedHeader
                    columns={this.props.columns}
                    pagination={this.props.pagination}
                    highlightOnHover
                    pointerOnHover
                    expandOnRowClicked
                    expandableRows={this.props.expandableRows}
                    expandableRowsComponent={
                        this.props.expandedComponent
                    }
                    onRowExpandToggled={(expanded: boolean) => {
                        this.setState({
                            isRowExpanded: expanded
                        })
                        console.log(expanded);
                    }}
                    customStyles={this.props.customStyles}
                    paginationServer
                    paginationTotalRows={this.props.paginationTotalRows}
                    onChangeRowsPerPage={this.props.onChangeRowsPerPage}
                    onChangePage={this.props.onChangePage}
                    onSort={this.props.onSort}
                    onRowClicked={this.props.onRowClicked}
                    style={this.props.style}
                    data={this.props.data}
                    conditionalRowStyles={this.props.conditionalRowStyles}
                    selectableRows={this.props.selectableRows}
                    onSelectedRowsChange={this.props.onSelectedRowsChange}
                    striped
                    responsive
                    clearSelectedRows={this.props.clearSelectedRows}
                />
            </>
        )
    }
}

export default DataGrid;